export const TIP_LIBRARY = '/p/tip-library';
export const DISABLE_EMAILS = '/p/disable-emails/:token';

const paths = {
  TIP_LIBRARY,
  DISABLE_EMAILS
};

export default paths;
